export const MarketingRoutes = { path: 'marketing/*', lazy: () => import('../pages/marketing') };
